import { computed } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';

export function useProductHub() {
  // Force-enable on localhost so devs don't need the AB flag toggled in their
  // session to see the Product Hub locally.
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  const isProductHubEnabled = computed(() => isLocalhost || !!app.abFeatures?.hasFeature('SHOW_PR_HUB'));

  return { isProductHubEnabled };
}
